<div class="help-icon">
  ?
  <div class="help-tooltip">
    <div class="text">{{ tooltipText }}</div>
    <a [routerLink]="link">{{ linkLabel }}</a>
  </div>
</div>
